import React from 'react';
import { motion } from 'framer-motion';
export function AboutPage() {
  return <div className="min-h-screen bg-sovereign-navy text-white pt-32 pb-20" data-id="element-152">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} data-id="element-154">
          <span className="text-sovereign-gold uppercase tracking-widest text-sm mb-8 block" data-id="element-155">
            Our Ethos
          </span>
          <h1 className="text-5xl md:text-7xl font-serif mb-12 leading-tight" data-id="element-156">
            The Art of <br data-id="element-157" />
            <span className="italic text-sovereign-gold" data-id="element-158">Compliance</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5,
        duration: 1
      }} className="space-y-8 text-xl font-light text-gray-300 leading-relaxed" data-id="element-159">
          <p data-id="element-160">
            Sovereign eTims was born from a simple observation: compliance
            software was functional, but rarely exceptional. It lacked the grace
            and precision that modern luxury commerce demands.
          </p>
          <p data-id="element-161">
            We set out to build not just a tool, but a standard. A system where
            accuracy is absolute, and operation is invisible.
          </p>
          <p data-id="element-162">
            Today, we serve a select group of merchants who refuse to compromise
            on quality, in their products or their operations.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-white/10 pt-12" data-id="element-163">
          {[{
          label: 'Precision',
          desc: 'Zero margin for error.'
        }, {
          label: 'Elegance',
          desc: 'Complexity made simple.'
        }, {
          label: 'Integrity',
          desc: 'Your data, protected.'
        }].map((item, i) => <div key={i} data-id="element-164">
              <h3 className="text-2xl font-serif text-white mb-2" data-id="element-165">
                {item.label}
              </h3>
              <p className="text-gray-500 text-sm uppercase tracking-widest" data-id="element-166">
                {item.desc}
              </p>
            </div>)}
        </motion.div>
      </div>
    </div>;
}